import { useState, useRef, useEffect } from 'react';
import ProgressBar from './ProgressBar';
import './Modal.scss';

// Material UI Imports
import {
  Typography,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// Package Imports
import ReactPlayer from 'react-player';

const Modal = ({ handleModalClose, open, data, pushAnalyticsRow }) => {
  // Hooks/State - START --------------------------------------------
  const [videoElement, setVideoElement] = useState(null);
  const [playing, setPlaying] = useState(false);
  const [playerState, setPlayerState] = useState({
    playedSeconds: 0,
    played: 0,
    loadedSeconds: 0,
    loaded: 0,
  });
  const [onDuration, setOnDuration] = useState();
  const [videoLoaded, setVideoLoaded] = useState(false);
  // Hooks/State - END ----------------------------------------------

  // Refs - START ---------------------------------------------------
  const player = useRef(null);
  // Refs - END -----------------------------------------------------

  // Handlers - START -----------------------------------------------
  const mediaLoadedHandler = () => {
    if (player.current) {
      let media = player.current.getInternalPlayer();
      if (media.nodeName === 'VIDEO') {
        setVideoElement(media);
      }
    }
    setVideoLoaded(true);
  };
  // Handlers - END -----------------------------------------------

  // useEffects - START -------------------------------------------

  useEffect(() => {
    const playVideo = () => {
      let timer = setTimeout(function () {
        setPlaying(true);
      }, 800);
      return () => {
        clearTimeout(timer);
      };
    };
    if (videoLoaded) playVideo();
  }, [videoLoaded]);
  // useEffects - END ---------------------------------------------

  return (
    <>
      <Dialog
        fullScreen
        maxWidth={'lg'}
        onClose={() => handleModalClose(data.index)}
        open={open}
        className='video-modal-container'
      >
        <DialogTitle className='video-modal-title'>
          <Typography variant='h5' color='primary.contrastText'>
            {data.title}
          </Typography>
          <Button
            onClick={() => {
              const timestamp = new Date();
              handleModalClose(data.index);
              pushAnalyticsRow(data.index, 'close', 'user', timestamp);
            }}
          >
            <CloseIcon sx={{ color: '#fff' }} />
          </Button>
        </DialogTitle>

        <DialogContent className='video-modal-content'>
          <ReactPlayer
            ref={player}
            url={data.videoUrl}
            className='react-player'
            playing={playing}
            volume={1}
            playsinline
            // config={reactPlayerConfig}
            controls={false}
            onProgress={setPlayerState}
            onDuration={setOnDuration}
            onEnded={() => {
              setPlaying(false);
              handleModalClose(data.index);
              const timestamp = new Date();
              pushAnalyticsRow(data.index, 'close', 'auto', timestamp);
            }}
            onReady={mediaLoadedHandler}
            onPlay={() => {
              setPlaying(true);
            }}
            onPause={() => {
              setPlaying(false);
            }}
            onError={(err) => {
              console.log('ERROR', err);
            }}
            preload='auto'
            width='100%'
            height='100%'
          />
        </DialogContent>
        <ProgressBar isEnabled value={playerState.playedSeconds / onDuration} />
      </Dialog>
    </>
  );
};

export default Modal;
